<template>
    <div class="pt-15 animated fadeIn equipmentList bgV2">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-card class="mb-0 heig-frame-child" fullContent>
                        <gofix-table
                            :settings="tableConfig"
                            :table-items="tableItems"
                            @load-items="getTableData"
                            @new-item="openModalAddressBook"
                            @row-click="openModalAddressBook"
                            @delete-items="deleteItems"
                            ref="gofixTable">
                        </gofix-table>
                    </gofix-card>
                    <b-modal :no-close-on-backdrop="true"
                        id="modal-Create"
                        :title="modals.addressBook.title" hide-footer :centered="true"
                        v-model="modals.addressBook.open">
                        <b-form class="pb-20">
                            <b-row>
                                <b-col md="12">
                                    <gofix-form-dropdown
                                        label="Client Contract"
                                        vLabel="contract_name"
                                        :filterable="false"
                                        :append-to-body="true"
                                        :required="true"
                                        :show-icon-required="true"
                                        :reduce="option => option.id"
                                        :options="modals.addressBook.options.contracts"
                                        @search="searchContract"
                                        v-model="modals.addressBook.data.contract_id">
                                    </gofix-form-dropdown>
                                </b-col>
                                <b-col md="12">
                                    <gofix-form-input label="Email" :required="true" :show-icon-required="true" v-model="modals.addressBook.data.email"></gofix-form-input>
                                </b-col>
                                <b-col md="12">
                                    <gofix-form-input label="First Name" :required="true" :show-icon-required="true" v-model="modals.addressBook.data.first_name"></gofix-form-input>
                                </b-col>
                                <b-col md="12">
                                    <gofix-form-input label="Last Name" :required="true" :show-icon-required="true" v-model="modals.addressBook.data.last_name"></gofix-form-input>
                                </b-col>
                                <b-col md="12">
                                    <gofix-form-input-number
                                        label="Phone Number"
                                        v-model="modals.addressBook.data.primary_phone"
                                        :integer-limit="15"
                                        :include-thousands-separator="false"
                                        :allowDecimal="false">
                                    </gofix-form-input-number>
                                </b-col>
                            </b-row>
                        </b-form>
                        <b-button-group class="d-block text-right">
                            <gofix-button label="SAVE" @click="save" :disabled="modals.addressBook.loading" noBorder></gofix-button>
                        </b-button-group>
                    </b-modal>
                </b-col>
            </b-row>
        </div>
    </div>
</template>
<script>
    import { filters } from '@/_filterVar.js'
    import { mapGetters } from 'vuex';
    export default {
        name: 'lmu-address-book',
        data () {
            let filter = JSON.parse(JSON.stringify(filters['lmu_address_book']));
            return {
                tableConfig:{
                    name: 'lmu-address-book',
                    controls:{
                        tableImport: false,
                        tableExport: false,
                        tableColumnSettings: false
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: false,
                    sortColumn: "id",
                    sortDirection: "asc",
                    fields: [
                        {
                            key: 'actions',
                            label: '',
                            thClass: 'checkbox-column text-center',
                            tdClass: 'checkbox-column text-center',
                            width: 50,
                            thStyle: "width: 50px",
                        },
                        {
                            key: 'id',
                            label: 'ID',
                            isActive: 1,
                            isFilter: true,
                            with:100,
                            thStyle: "width: 100px",
                            sorting: true,
                        },
                        {
                            key: 'display_name',
                            label: 'Name',
                            isActive: 1,
                            isFilter: true,
                            with:350,
                            thStyle: "width: 350px",
                            sorting: true,
                        },
                        {
                            key: 'email',
                            label: 'Email',
                            isActive: 1,
                            isFilter: true,
                            with:300,
                            thStyle: "width: 300px",
                            sorting: true,
                        },
                        {
                            key: 'primary_phone',
                            label: 'Phone Number',
                            thClass: 'th-auto',
                            isActive: 1,
                            isFilter: true,
                            sorting: true,
                        }
                    ]
                },
                tableItems: [],
                modals:{
                    addressBook:{
                        open: false,
                        loading: false,
                        title:"Add Address Book",
                        data:{
                            id: null,
                            email: null,
                            primary_phone: null,
                            first_name: null,
                            last_name: null,
                            contract_id: null
                        },
                        options: {
                            contracts: []
                        }
                    }
                },
                timer: {
                    save: null,
                    contracts: null
                }
            }
        },
        computed: {
            ...mapGetters({
                ClientContractID: 'ContractController/ClientContractID'
            })
        },
        watch: {

        },
        created() {
            this.getContracts()
        },
        methods:{
            async getTableData(callback) {
                const { tableRequest , resolve,reject } = await callback();
                tableRequest.filter.contact_name = {"type":"text","value":"LMU","function":"ilike","with":[]}
                await this.$store.dispatch("LMUAddressBookController/getItems", tableRequest)
                .then(response => {
                    this.tableItems = response.items;
                    this.tableConfig.total = response.total;
                    resolve(response);
                })
                .catch(err => {
                    console.log(err);
                    this.$alertNotification("Can not load the items", "danger");
                    reject();
                })
            },
            async deleteItems(callback){
                const { ids,filter, resolve,reject } = await callback();
                this.$store.dispatch("LMUAddressBookController/deleteItems", ids)
                    .then(response => {
                        resolve(this.$notificationV2('deleting', 'nlt_address_book'));
                    })
                    .catch(err =>{
                        reject(err);
                    });
            },
            /*-- Validation Data --*/
            emailValidationCheckFormat(email_address){
                if(email_address && email_address != ''){
                    let pattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/;
                    let result = pattern.test(email_address);
                    return result;
                }
                return true;
            },
            /*-- Store Data --*/
            openModalAddressBook(item){
                this.modals.addressBook.open = true;
                if ( item ) {
                    this.modals.addressBook.title = "Edit Address Book";
                    this.modals.addressBook.data = {
                        id: item.id,
                        contact_name: item.contact_name,
                        email: item.email,
                        primary_phone: item.primary_phone,
                        first_name: item.first_name,
                        last_name: item.last_name,
                        contract_id: item.contract_id
                    };
                } else {
                    this.modals.addressBook.title = "Add Address Book";
                    this.modals.addressBook.data = {
                        id: null,
                        contact_name: 'LMU',
                        email: null,
                        primary_phone: null,
                        first_name: null,
                        last_name: null,
                        contract_id: this.ClientContractID && this.ClientContractID.id ? this.ClientContractID.id : null
                    };
                }
            },
            save() {
                if (this.timer.save) {
                    clearTimeout(this.timer.save);
                    this.timer.save = null;
                }
                this.timer.save = setTimeout(() => {
                    if(!this.modals.addressBook.data.contract_id) return this.$alertNotification("Client contract is required.", "danger");
                    if(!this.modals.addressBook.data.email) return this.$alertNotification("Email is required.", "danger");
                    if(!this.modals.addressBook.data.first_name) return this.$alertNotification("First Name is required.", "danger");
                    if(!this.modals.addressBook.data.last_name) return this.$alertNotification("Last Name is required.", "danger");
                    
                    if(!this.emailValidationCheckFormat(this.modals.addressBook.data.email)) {
                        return this.$alertNotification("Email is not in a correct format.", "danger");
                    }

                    if(this.modals.addressBook.loading) return;
                    this.modals.addressBook.loading = true;
                    let request = JSON.parse(JSON.stringify(this.modals.addressBook.data));
                    let action = 'createItem';
                    let keyMsg = 'adding'

                    if(request.id){
                        action = 'updateItem';
                        keyMsg = 'editing'
                    }
                    this.$store.dispatch(`LMUAddressBookController/${action}`, request)
                        .then(result => {
                            this.modals.addressBook.loading = false;
                            this.modals.addressBook.open = false;
                            this.$alertNotification(this.$notificationV2(keyMsg, 'nlt_address_book'));
                            this.$refs.gofixTable.reloadTableKeepFilter();
                        })
                        .catch(error => {
                            console.log(error)
                            this.modals.addressBook.loading = false;
                            if(error.response) this.$alertNotification(error.response.data.error.message.error, "danger");
                        })
                }, 300);
            },
            /*-- Get Data --*/
            async getContracts(filter = null) {
                await this.$store.dispatch('ContractController/getListClientContractsSearch', [1, filter, 1000])
                .then(response => {  
                    this.modals.addressBook.options.contracts = response.data; 
                }).catch(error => {
                    console.log(error);
                })
            },
            searchContract(search, loading){
                this.modals.addressBook.options.contracts = []
                loading(true);
                if(this.timer.contracts) {
                    clearTimeout(this.timer.contracts);
                    this.timer = null;
                }
                this.timer.contracts = setTimeout(async () => {
                    try {
                        await this.getContracts({ contract_name: search });
                        await loading(false);
                    } catch (err) {
                        loading(false);
                    }
                }, 500);
            },
        }
    }
</script>